import { Button, DialogActions, DialogContent, Grid, Typography } from '@material-ui/core';
import PropTypes from "prop-types";
import React from 'react';
import { multipleOperationOff, multipleOperationOn, singleOperationOff, singleOperationOn } from '../../../../asset';
import WorkCombinationBarChart from '../charts/WorkCombinationBarChart';
import PrintIcon from '@material-ui/icons/Print'
import reportsCommonStyles from '../StudyBrowserReports.module.scss'
import { utilFunctions } from '../../../../_helpers'

const TimeStudyReport = (props) => {
    return (
        <React.Fragment>
            <DialogContent>
                <Grid container>
                    <Grid container item xs={12} sm={12} md={6} lg={6} className={reportsCommonStyles.summaryInfoContainer}>
                        <Grid
                            container
                            item
                            xs={6}
                            sm={6}
                            direction="column"
                            alignItems="flex-start"
                            justify="center"
                            className={reportsCommonStyles.summaryInfoGroup}
                        >
                            <Typography>Total Elapsed Time</Typography>
                            <div>{props.reportData.totalElapsedTime?.min}<sub>MIN</sub> {props.reportData.totalElapsedTime?.sec}<sub>SEC</sub></div>
                        </Grid>
                        <Grid
                            container
                            item
                            xs={6}
                            sm={6}
                            direction="column"
                            alignItems="flex-start"
                            justify="center"
                            className={reportsCommonStyles.summaryInfoGroup}
                        >
                            <Typography>Total Study PCS/HRS</Typography>
                            <div>{props.reportData.totalStudyPcs}<sub>PCS/HRS</sub></div>
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} sm={12} md={6} lg={6} className={reportsCommonStyles.infoContainer}>
                        <Grid container item xs={12} sm={6} className={reportsCommonStyles.infoGroup}>
                            <Grid item xs={4}>EPF</Grid>
                            <Grid item xs={8} className="uppercase bold">{props.reportData.epf}</Grid>
                        </Grid>
                        <Grid container item xs={12} sm={6} className={reportsCommonStyles.infoGroup}>
                            <Grid item xs={4}>OPERATION MODE</Grid>
                            <Grid item xs={8} className="uppercase bold">
                                {!props.reportData.isMultiple ?
                                    <img src={singleOperationOn} /> :
                                    <img src={singleOperationOff} />}
                                {props.reportData.isMultiple ?
                                    <img src={multipleOperationOn} /> :
                                    <img src={multipleOperationOff} />}
                            </Grid>
                        </Grid>
                        <Grid container item xs={12} sm={6} className={reportsCommonStyles.infoGroup}>
                            <Grid item xs={4}>TM NAME</Grid>
                            <Grid item xs={8} className="uppercase bold">{props.reportData.tmName}</Grid>
                        </Grid>
                        <Grid container item xs={12} sm={6} className={reportsCommonStyles.infoGroup}>
                            <Grid item xs={4}>CREATED AT</Grid>
                            <Grid item xs={8} className="uppercase bold">{props.reportData.createdAt}</Grid>
                        </Grid>
                        <Grid container item xs={12} sm={6} className={reportsCommonStyles.infoGroup}>
                            <Grid item xs={4}>OPERATION</Grid>
                            <Grid item xs={8} className="uppercase bold">{props.reportData.operation}</Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12} sm={12} md={6}>
                        <WorkCombinationBarChart
                            categories={props.reportData?.barChartData?.categories}
                            data={props.reportData?.barChartData?.data}
                            width='100%'
                            height={300}
                        />
                    </Grid>
                    <Grid container item xs={12} sm={12} md={6}>
                        <Grid item xs={4} sm={4} className={`${reportsCommonStyles.dataContainer}`}>
                            <label>GSD SMV</label>
                            <span>{utilFunctions.formatCycleTimes(props.reportData.gsdSmv)}</span>
                        </Grid>
                        <Grid item xs={4} sm={4} className={`${reportsCommonStyles.dataContainer} ${reportsCommonStyles.lite}`}>
                            <label>GSD 100% TGT</label>
                            <span>{props.reportData.gds100Tgt} <sub>PCS</sub></span>
                        </Grid>
                        <Grid item xs={4} sm={4} className={`${reportsCommonStyles.dataContainer}`}>
                            <label>GSD 80% TGT</label>
                            <span>{props.reportData.gds80Tgt} <sub>PCS</sub></span>
                        </Grid>
                        <Grid item xs={4} sm={4} className={`${reportsCommonStyles.dataContainer} ${reportsCommonStyles.lite}`}>
                            <label>Time study SMV</label>
                            <span>{utilFunctions.formatCycleTimes(props.reportData.timeStudySmv)}</span>
                        </Grid>
                        <Grid item xs={4} sm={4} className={`${reportsCommonStyles.dataContainer}`}>
                            <label>100% TGT (Time Study)</label>
                            <span>{props.reportData.tgt100} <sub>PCS</sub></span>
                        </Grid>
                        <Grid item xs={4} sm={4} className={`${reportsCommonStyles.dataContainer} ${reportsCommonStyles.lite}`}>
                            <label>GSD vs Time Study</label>
                            <span>{props.reportData.gsdVsTimeStudy}%</span>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions className="isPrintViewHidden">
                <Button color="primary" variant='contained' onClick={() => window.print()}><PrintIcon /> Print Report</Button>
            </DialogActions>
        </React.Fragment>
    )

}

TimeStudyReport.propTypes = {
    reportData: PropTypes.object.isRequired,
}

export default TimeStudyReport;